"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FLYWIRE_INITIAL = 'F';
// Construct the order ID or payment reference for payment posting into GuestCentrix
// Add an identifier at the beginning to identify the Payment Service Provider (PSP) on GuestCentrix
// e.g.: "({PSP Initial}){Tenant label}{Folio ID}-{Flywire Reference ID}"
//       "(F)KN100123-KKO853101482"
function composePaymentReference(referenceId, tenantLabel, folioId) {
    return "(".concat(FLYWIRE_INITIAL, ")").concat(tenantLabel).concat(folioId, "-").concat(referenceId);
}
exports.default = composePaymentReference;
